module.exports = __webpack_public_path__ + "img/calendar-6_fill.4ae8f865.svg";